import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b6e1667"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "line-clamp",
  style: {"white-space":"pre-line"}
}
const _hoisted_5 = { style: {"white-space":"pre-line","overflow":"scroll"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_7 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_loading_skeleton = _resolveComponent("loading-skeleton")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openBrowser($setup.settings.bandGroupLink)))
              }, {
                default: _withCtx(() => [
                  ($setup.latestBandPosts.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_avatar, {
                        key: 0,
                        style: {"height":"36px","width":"36px","margin-left":"16px"},
                        slot: "start"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: $setup.latestBandPosts[0].author.profileImageUrl
                          }, null, 8, _hoisted_1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  ($setup.latestBandPosts.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_title, {
                        key: 1,
                        style: {"text-align":"left","padding-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", null, _toDisplayString($setup.latestBandPosts[0]?.author.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    style: {"width":"50px","margin-right":"16px"},
                    slot: "end",
                    src: require('@/assets/BAND_LOGO_green.png')
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              ($setup.loading)
                ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 0 }))
                : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.latestBandPosts, (post) => {
                        return (_openBlock(), _createBlock(_component_ion_card, {
                          key: post.postKey,
                          button: "",
                          onClick: ($event: any) => {$setup.isBandPostModalOpened = true; $setup.readMorePost = post}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, null, {
                              default: _withCtx(() => [
                                ($setup.getMainPostPhoto(post))
                                  ? (_openBlock(), _createBlock(_component_ion_col, {
                                      key: 0,
                                      size: "5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          class: "main-post-img",
                                          src: $setup.getMainPostPhoto(post)
                                        }, null, 8, _hoisted_3)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_ion_col, { size: "7" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_header, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.getRelativeDate(post.createdAt)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_card_content, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_4, _toDisplayString(post.content), 1),
                                        _createVNode(_component_ion_button, {
                                          size: "small",
                                          fill: "clear"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.t('readMore')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })),
              _createVNode(_component_ion_modal, {
                mode: "ios",
                "is-open": $setup.isBandPostModalOpened,
                onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => ($setup.isBandPostModalOpened = false)),
                breakpoints: [0, 1],
                "initial-breakpoint": 1,
                "keep-contents-mounted": true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isBandPostModalOpened = false))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.getRelativeDate($setup.readMorePost.createdAt)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_5, _toDisplayString($setup.readMorePost.content), 1),
                              _hoisted_6,
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.readMorePost.photos, (photo) => {
                                    return (_openBlock(), _createBlock(_component_ion_col, {
                                      class: "ion-text-center",
                                      size: "12",
                                      key: photo.photoKey
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: photo.url,
                                          onClick: ($event: any) => ($setup.openImageModal(photo.url, ''))
                                        }, null, 8, _hoisted_7)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-open"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}